import React from 'react'
import ReactDatePicker from 'react-datepicker'
import { ValidationIssue } from 'api'
import { Field } from './Field'
import 'react-datepicker/dist/react-datepicker.css'
import './DatePicker.css'
import { ValidationTooltip } from '../tooltip'
import styled from '@emotion/styled'
import { StyledInput } from './BaseInput'

export interface TimePickerProps {
  id?: string
  value: Date | null
  validationIssues?: ValidationIssue[]
  readOnly?: boolean
  disabled?: boolean
  dataTestId?: string
  onUpdate: (value: Date | null) => unknown
}

const ReactDatePickerStyled = styled(StyledInput.withComponent(ReactDatePicker))`
  cursor: pointer;
  padding-right: 30px;
`

const TimePickerInput = React.forwardRef((props: any, ref: React.Ref<any> | null) => {
  const { validationIssues, dataTestId, ...rest } = props

  return (
    <ValidationTooltip validationIssues={validationIssues || []}>
      <input data-test-id={dataTestId} ref={ref} {...rest} onFocusCapture={evt => evt.currentTarget.select()} />
    </ValidationTooltip>
  )
})

export class TimePicker extends React.Component<TimePickerProps> {
  render() {
    const { value, onUpdate, dataTestId, validationIssues, readOnly, disabled, id } = this.props

    return (
      <ReactDatePickerStyled
        id={id}
        customInput={<TimePickerInput dataTestId={dataTestId} validationIssues={validationIssues} />}
        selected={value}
        onChange={onUpdate}
        showTimeSelect={true}
        showTimeSelectOnly={true}
        timeIntervals={60}
        dateFormat="HH:mm"
        timeFormat="HH:mm"
        disabled={disabled}
        readOnly={readOnly}
        validationIssues={validationIssues}
        timeCaption={''}
      />
    )
  }
}

export const TimePickerField = Field(TimePicker)
